export default "__VITE_ASSET__DSj7vCKj__"